const MERGE_ACCOUNT_CONSTANTS = {
  BTN_LOADER: 'BTN_LOADER',
  IS_FROM_OTP: 'IS_FROM_OTP',
  MERGE_ACCOUNT_SUCCESS: 'MERGE_ACCOUNT_SUCCESS',
  MERGE_ACCOUNT_FAILED: 'MERGE_ACCOUNT_FAILED',
  MERGE_ACCOUNT_RESET: 'MERGE_ACCOUNT_RESET',
  MERGE_ACCOUNT: 'MERGE_ACCOUNT',
  ACCOUNT_STATUS: {
    0: 'UNLOCKED',
    1: 'LOCKED',
  },
  MERGE_STATUS: {
    MERGE_SUCCESS: 'MERGE_SUCCESS',
    MERGE_FAILED: 'MERGE_FAILED',
  },
  recaptchaThresholdDefault: 3,
  SET_NUMBER_OF_RETRIES: 'NUMBER_OF_RETRIES',
  SET_ACCOUNT_STATUS: 'SET_ACCOUNT_STATUS',
  SET_FIRST_TIME_OTP: 'SET_FIRST_TIME_OTP',
  SET_SHOW_CONFIRMATION_MODAL: 'SET_SHOW_CONFIRMATION_MODAL',
  SET_MERGE_CONFIRMED: 'SET_MERGE_CONFIRMED',
};

export default MERGE_ACCOUNT_CONSTANTS;
